module.exports = __webpack_public_path__ + "img/instagram.fec10b4c.png";